import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';

const DischargeLayout: React.FC = () => {
  const location = useLocation();

  if (location.pathname === '/discharge' || location.pathname === '/discharge/') {
    return <Navigate to="/discharge/all-patients" replace />;
  }

  return <Outlet />;
};

export default DischargeLayout;
